import { Injectable } from '@angular/core';
import { UniversityReview } from '@uc/web/shared/data-models';

@Injectable({
	providedIn: 'root',
})
export class ReviewCardService {
	editReactionStatus(review: UniversityReview, reaction: 1 | 2) {
		if (reaction === 1) {
			if (review.reaction === null) {
				review.reaction = 'LIKE';
				review.likes++;
				return;
			} else if (review.reaction === 'LIKE') {
				review.reaction = null;
				review.likes--;
				return;
			} else {
				review.reaction = 'LIKE';
				review.likes++;
				review.dislikes--;
				return;
			}
		}
		if (review.reaction === null) {
			review.reaction = 'DISLIKE';
			review.dislikes++;
		} else if (review.reaction === 'DISLIKE') {
			review.reaction = null;
			review.dislikes--;
		} else {
			review.reaction = 'DISLIKE';
			review.dislikes++;
			review.likes--;
		}
	}

	getRandomAvatar(): string {
		const prefix = 'da';
		const randomNum = Math.ceil(Math.random() * 13);
		return `/img/${prefix}${randomNum}.svg`;
	}
}
